<template>
  <div>
    <el-row style="margin-top:10px">
      <el-col>
        <el-button size="medium" @click="addLine">新增匹配</el-button>
      </el-col>
    </el-row>
    <el-row style="margin-top:10px">
      <el-col>
        <el-table stripe border :data="tableData">
          <el-table-column type="index" label="序号" width="80"></el-table-column>
          <el-table-column prop="LICENSE_PLATE" label="车牌号"></el-table-column>
          <el-table-column prop="DRIVER" label="联系人"></el-table-column>
          <el-table-column prop="CELLPHONE" label="联系电话"></el-table-column>
          <el-table-column label="操作" width="200px">
            <template slot-scope="scope">
              <el-button type="text" @click="cancel(scope.row)">解除匹配</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-dialog title="新增匹配" center :visible.sync="addFormVisible" width="600px">
      <el-form :model="addForm" ref="addForm">
        <el-form-item label="匹配车辆：" :label-width="formLabelWidth">
          <el-select filterable v-model="addForm.CAR_ID" clearable placeholder="请选择" style="width:400px;">
            <el-option v-for="item in allCar" :key="item.CAR_ID" :label="item.LICENSE_PLATE" :value="item.CAR_ID">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="addFormVisible = false">取 消</el-button>
        <el-button size="small" @click="submitAdd()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import http from '@/assets/common/http';

export default {
  data() {
    return {
      tableData: [],
      rowMsg: {},
      addFormVisible: false,
      addForm: {},
      formLabelWidth: '100px',
      allCar: [],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // 拉取
    getList() {
      const params = {
        SERVICE_ID: '12011',
        OTYPE: 12,
        LINE_ID: this.$route.params.id,
      };
      http.post(params).then((result) => {
        this.tableData = result;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 新增
    addLine(row) {
      const params = {
        SERVICE_ID: '12011',
        OTYPE: 9,
        COMPANY_TYPE: 2,
        COMPANY_ID: sessionStorage.getItem('tcId'),
      };
      http.post(params).then((result) => {
        this.allCar = result;
        this.addFormVisible = true;
        this.addForm = {};
        this.rowMsg = row;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 新增确认
    submitAdd() {
      const params = {
        SERVICE_ID: '12011',
        OTYPE: 10,
        LINE_ID: this.$route.params.id,
        CAR_ID_LIST: [this.addForm.CAR_ID],
      };
      http.post(params).then((result) => {
        this.getList();
        this.addFormVisible = false;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 取消确认
    cancel(row) {
      this.$confirm('是否解除匹配?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const params = {
          SERVICE_ID: '12011',
          OTYPE: 11,
          CAR_ID: row.CAR_ID,
        };
        http.post(params).then((result) => {
          this.getList();
          this.addFormVisible = false;
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
        this.$message.show({ text: '解除成功', type: 'success' });
      }).catch(() => {
        this.$message.show({ text: '已取消操作', type: 'info' });
      });
    },
  },
};
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/sortingAndDistribution/matchCar.vue